<template>
  <div>
    <BlocoFiltroPesquisa
      nome-do-form="AtendimentoPlanoForm"
      :ordenar-por="['plano', 'quantidade', 'especialidade', 'unidade']"
      :ordenar-nomes="[
        'Plano',
        'Quantidade (decrescente)',
        'Especialidade',
        'Unidade',
      ]"
      :botao-adicionar="false"
      @pesquisar="pesquisar"
      @ordenar="ordenar"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <SelecionarUnidade
              :mostrar-todos="false"
              :validacao="v$.filtro.unidade"
              @atualizar="filtro.unidade = $event"
              @pronto="filtro.unidade = $event[0].nome"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <SelecionarEspecialidade
              @atualizar="filtro.especialidade = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
            <SelecionarData
              id="dataInicio"
              :valor="filtro.dataInicio"
              :validacao="v$.filtro.dataInicio"
              label="Data Início"
              @atualizar="filtro.dataInicio = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
            <SelecionarData
              id="dataFim"
              :valor="filtro.dataFim"
              :validacao="v$.filtro.dataFim"
              label="Data Fim"
              @atualizar="filtro.dataFim = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <br />
    <AtendimentoPlanoTabela v-if="valores.length" :valores="valores" />
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import moment from 'moment'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import SelecionarEspecialidade from '@/componentes/formulario/SelecionarEspecialidade'
import SelecionarUnidade from '@/componentes/formulario/SelecionarUnidade'
import { useMenu } from '@/composables/useMenu'
import AgendamentoServico from '@/servicos/AgendamentoServico'
import MensagemServico from '@/servicos/MensagemServico'

import AtendimentoPlanoTabela from './AtendimentoPlanoTabela'
const mensagemServico = new MensagemServico()

export default {
  components: {
    AtendimentoPlanoTabela,
    BlocoFiltroPesquisa,
    SelecionarUnidade,
    SelecionarEspecialidade,
    SelecionarData,
  },

  setup() {
    useMenu(34)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      solicitantes: [],
      valores: [],
      servico: new AgendamentoServico(),
      nomeResultado: 'valores',
      filtro: {
        dataInicio: moment().startOf('month'),
        dataFim: moment().endOf('month'),
        unidade: '',
        especialidade: '',
        ordenarPor: 'unidade',
      },
    }
  },
  computed: {
    dataInicio() {
      return moment().subtract(1, 'M').format('DD/MM/YYYY')
    },
    dataFim() {
      return moment().format('DD/MM/YYYY')
    },
  },
  validations: {
    filtro: {
      unidade: { required },
      dataInicio: { required },
      dataFim: { required },
    },
  },
  methods: {
    pesquisar() {
      this.v$.$touch()

      if (this.v$.filtro.$invalid) {
        mensagemServico.alerta('Informe a Unidade, Data Início e Data Fim.')
      } else {
        this.servico.relatorioAtendimentoConvenio(this.filtro).then((res) => {
          this.valores = res.dados
        })
      }
    },
    ordenar(prop) {
      this.filtro.ordenarPor = prop
      this.pesquisar()
    },
  },
}
</script>
